import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { apiService } from '../services/api';
import NavigationBar from './NavigationBar';
import EventNavigation from './EventNavigation';
import LoadingSpinner from './LoadingSpinner';
import './EventHome.css';

const EventSponsors = () => {
    const { eventNameId } = useParams();
    const navigate = useNavigate();
    const [event, setEvent] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        if (eventNameId) {
            localStorage.setItem('last_event', eventNameId);
            fetchEventData();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [eventNameId]);

    const fetchEventData = async () => {
        try {
            setLoading(true);
            const response = await apiService.getEventByNameId(eventNameId);
            setEvent(response.data);
        } catch (err) {
            console.error('Error fetching event:', err);
            setError('Failed to load event details');
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <>
                <NavigationBar />
                <div className="event-layout">
                    <EventNavigation eventNameId={eventNameId} />
                    <div className="event-home-container with-sidebar">
                        <LoadingSpinner message="Loading sponsors..." />
                    </div>
                </div>
            </>
        );
    }

    if (error || !event) {
        return (
            <>
                <NavigationBar />
                <div className="event-layout">
                    <EventNavigation eventNameId={eventNameId} />
                    <div className="event-home-container with-sidebar">
                        <div className="error-message">
                            <h2>Error</h2>
                            <p>{error || 'Event not found'}</p>
                            <button onClick={() => navigate('/login')} className="btn btn-primary">
                                Return to Login
                            </button>
                        </div>
                    </div>
                </div>
            </>
        );
    }

    return (
        <>
            <NavigationBar />
            <div className="event-layout">
                <EventNavigation eventNameId={eventNameId} />
                <div className="event-home-container with-sidebar">
                    <div className="event-content">
                        <h1>Sponsors</h1>
                        <p className="event-subtitle">
                            Our valued sponsors for {event.Name}
                        </p>
                        {/* Sponsors content will go here */}
                        <div style={{ padding: '20px', background: '#f9fafb', borderRadius: '8px', marginTop: '20px' }}>
                            <p>Sponsor information and logos will be displayed here.</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default EventSponsors;

